import { useControls } from '@/components/multistep/useMultistep';
import { useCategories, useManufacturers } from '@/services/api/hooks/catalog';
import { useRegions } from '@/services/api/hooks/region';
import { useCallback } from 'react';
import { Result } from '../bulkUploadHelper';
import { getMismatchedCategories, getMismatchedManufacturers, getMismatchedRegions } from '../helpers/getMismatched';

export const useBulkProductSmartNext = () => {
  const { skipToStep } = useControls();

  const [regions] = useRegions();
  const [manufacturers] = useManufacturers();
  const [categories] = useCategories();

  return useCallback(
    async (result: Result) => {
      const mismatchedManufacturers = getMismatchedManufacturers(result, manufacturers);

      // If there are any mismatched manufacturers, show them
      if (mismatchedManufacturers.length !== 0) {
        skipToStep('manufacturers');
        return;
      }

      const mismatchedCategories = getMismatchedCategories(result, categories);
      if (mismatchedCategories.length !== 0) {
        skipToStep('categories');
        return;
      }

      const mismatchedRegions = getMismatchedRegions(result, regions);
      if (mismatchedRegions.length !== 0) {
        skipToStep('regions');
        return;
      }

      // If there are no interventions needed, skip to the review step
      skipToStep('review');
    },
    [regions, manufacturers, categories]
  );
};
